import { render, staticRenderFns } from "./Limits.vue?vue&type=template&id=1ef50f89"
import script from "./Limits.vue?vue&type=script&lang=ts"
export * from "./Limits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports